import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import localforage from 'localforage';
import Home from '../pages/Home/Home';
import Destinations from '../pages/Destinations/Destinations.js';
import Login from '../pages/Login/LoginForm/Login.js';
import Signup from '../pages/Login/LoginForm/Signup.js';
import Footer from '../Components/Footer/Footer';
import Header from '../Components/Header/Header';
import HotelsInSemera from '../pages/TouristFascilities/Hotels/HotelsInSemera.js';
import FlightInfoPage from '../pages/TouristFascilities/Flights/FlightInfoPage.js';
import NewsEventGrid from '../pages/EventsAndNews/NewsEventGrid.js';
import ContactUs from '../pages/ContactUs/ContactUs';
import ThingsTodo from '../pages/TouristFascilities/ThingsTodo/ThingsTodo.js';
import TouristInfo from '../pages/TouristFascilities/TouristInfo/TouristInfo.js';
import TravelAgencies from '../pages/TouristFascilities/TravelAgencies/TravelAgencies';
import ACTB from '../pages/About/AboutACTB.js';
import AA from '../pages/About/AboutAfar.js';
import Cultural from '../pages/Attractions/cultural/CulturalPage.js';
import Dashboard from '../AdminPage/Components/Dashbord.jsx';
import Profile from '../AdminPage/Components/Profile/Profile.jsx';
import AdminLogin from '../AdminPage/Auth/Login.jsx';
import SingleAgencyPage from '../pages/TouristFascilities/TravelAgencies/SingleAgencyPage.js';
import Archaeological from '../pages/Attractions/historical/Archaeological';
import VolcanoesAndRiftvalleys from '../pages/Attractions/natural/VolcanoesAndRiftvalleys';
import Natural from '../pages/Attractions/natural/natural';
import SaltPlainsAndLakes from '../pages/Attractions/natural/SaltPlainsAndLakes';
import HydrothermalAndSulfurSprings from '../pages/Attractions/natural/HydrothermalAndSulfurSprings';
import DesertAndCanyons from '../pages/Attractions/natural/DesertAndCanyons';
import Historical from '../pages/Attractions/historical/historical';
import NewseventsDetail from '../pages/EventsAndNews/NewsDetail.js';
// import NewseventsDetail from '../pages/EventsAndNews/NewsDetail.js';
// Protected Route Component
const ProtectedAdminRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const token = await localforage.getItem('token');
        // Basic token validation (adjust based on your token structure)
        setIsAuthenticated(token && token.length > 0); 
      } catch (error) {
        console.error("Failed to retrieve token", error);
      } finally {
        setLoading(false);
      }
    };
    checkAuth();
  }, []);

  if (loading) return <div>Loading...</div>; // Optionally show a loading spinner

  return isAuthenticated ? children : <Navigate to="/admin/login" />;
};

const PublicLayout = ({ children }) => (
  <>
    <Header />
    {children}
    <Footer />
  </>
);

const AppRouter = () => (
  <Routes>
    {/* Public Routes */}
    <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
      <Route path="/destinations" element={<PublicLayout><Destinations /></PublicLayout>} />
      <Route path="/things-todo" element={<PublicLayout><ThingsTodo/></PublicLayout>} />
      <Route path="/about-region" element={<PublicLayout><AA /></PublicLayout>} />
      <Route path="/about-actb" element={<PublicLayout><ACTB /></PublicLayout>} />
      <Route path="/travelagencies" element={<PublicLayout><TravelAgencies /></PublicLayout>} />
      <Route path="/contact-us" element={<PublicLayout><ContactUs /></PublicLayout>} />
      <Route path="/news-events" element={<PublicLayout><NewsEventGrid /></PublicLayout>} />
      <Route path="/news-events/id" element={<PublicLayout><NewseventsDetail /></PublicLayout>} />
      <Route path="/hotels" element={<PublicLayout><HotelsInSemera /></PublicLayout>} />
      <Route path="/tourist-info" element={<PublicLayout><TouristInfo /></PublicLayout>} />
      <Route path="/signup" element={<PublicLayout><Signup /></PublicLayout>} />
      <Route path="/login" element={<PublicLayout><Login /></PublicLayout>} />
      <Route path="/flights" element={<PublicLayout><FlightInfoPage /></PublicLayout>} />
      <Route path="/cultural-experiences" element={<PublicLayout><Cultural /></PublicLayout>} />
      <Route path="/archaeological-sites" element={<PublicLayout><Archaeological /></PublicLayout>} />
      <Route path="/adventure-activities" element={<PublicLayout><VolcanoesAndRiftvalleys /></PublicLayout>} />
      <Route path="/natural" element={<PublicLayout><Natural /></PublicLayout>} />
      <Route path="/SaltPlainsAndLakes" element={<PublicLayout><SaltPlainsAndLakes /></PublicLayout>} />
      <Route path="/HydrothermalAndSulfurSprings" element={<PublicLayout><HydrothermalAndSulfurSprings /></PublicLayout>} />
      <Route path="/desert-canyons" element={<PublicLayout><DesertAndCanyons /></PublicLayout>} />
      <Route path="/single-agency/:id" element={<PublicLayout><SingleAgencyPage /></PublicLayout>} />
      <Route path="/historical" element={<PublicLayout><Historical /></PublicLayout>} />

    {/* Admin Routes */}
    <Route path="/admin/login" element={<AdminLogin />} />
    <Route
      path="/admin/dashboard"
      element={
        <ProtectedAdminRoute>
          <Dashboard />
        </ProtectedAdminRoute>
      }
    />
    <Route
      path="/admin/profile"
      element={
        <ProtectedAdminRoute>
          <Profile />
        </ProtectedAdminRoute>
      }
    />

    {/* Catch all route */}
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes>
);

export default AppRouter;